<template>
  <div class="m-2">
    <span v-if="userReceived">
      Du hast eine Freundschaftsanfrage von
      <strong v-html="senderLink"></strong> erhalten
    </span>
    <span v-else>
      Du hast eine Freundschaftsanfrage an
      <strong v-html="receiverLink"></strong> gesendet
    </span>
    <div v-if="open">
      <div v-if="message.sender && userReceived && !processed">
        <div v-if="processing">
          <div class="btn btn-sm">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
        </div>
        <div v-else-if="!is_in_moderation">
          <div @click="accept()" class="btn btn-sm btn-primary">
            Akzeptieren
          </div>
          <div @click="decline()" class="btn btn-sm btn-secondary">
            Ablehnen
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <span v-if="accepted">
        Sie wurde akzeptiert
      </span>
      <span v-else>
        Sie wurde abgelehnt
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message", "profile"],
  data() {
    return {
      processing: false,
      processed: false,
      accepted_now: null
    };
  },
  computed: {
    is_in_moderation() {
      return this.$store.getters["user/me"].roles
        .map(role => role.name)
        .includes("moderator");
    },
    userReceived() {
      return this.message.sender_id !== this.profile.id;
    },
    friendId() {
      return this.message.meta["\\App\\CustomerProfileFriend"].id;
    },
    accepted() {
      return (
        Boolean(this.message.meta["\\App\\CustomerProfileFriend"].accepted) ||
        this.accepted_now
      );
    },
    open() {
      return (
        this.message.meta["\\App\\CustomerProfileFriend"].accepted === null &&
        this.accepted_now === null
      );
    },
    senderLink() {
      if (!this.message.sender) {
        return `<span class="font-italic">Gelöscht</span>`;
      }

      return `<a href="/mitglied/${this.message.sender.name}">${this.message.sender.name}</a>`;
    },
    receiverLink() {
      if (!this.message.receiver) {
        return `<span class="font-italic">Gelöscht</span>`;
      }

      return `<a href="/mitglied/${this.message.receiver.name}">${this.message.receiver.name}</a>`;
    }
  },
  methods: {
    accept() {
      this.processing = true;
      this.$http
        .post(`/api/v1/friends/${this.friendId}/accept`)
        .then(() => {
          this.accepted_now = true;
        })
        .catch(error => {
          this.$notify({
            title: error.response.data.message,
            type: "error"
          });
        })
        .finally(() => {
          this.processed = true;
        });
    },
    decline() {
      this.processing = true;
      this.$http
        .post(`/api/v1/friends/${this.friendId}/decline`)
        .then(() => {
          this.accepted_now = false;
        })
        .catch(error => {
          this.$notify({
            title: error.response.data.message,
            type: "error"
          });
        })
        .finally(() => {
          this.processed = true;
        });
    }
  }
};
</script>
